export enum OperationTypeEnum {
  PRODUCTION = 'production',
  INSTALLATION = 'installation',
}
